// tools and component for date picker
import dayjs from 'dayjs';

import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';

//data:
import shortNamesList from '../../database/articles_short_names.json'
import { appURL } from '../../config/api-config';

//MUI
import UploadIcon from '@mui/icons-material/Upload';
import DownloadIcon from '@mui/icons-material/Download';

//import fr from 'dayjs/locale/fr';
const fr = require('dayjs/locale/fr')
dayjs.locale(fr);

console.log(fr);

const weekday = require('dayjs/plugin/weekday')
dayjs.extend(weekday)


function ligneTotalJour({ contrats, sens, dateRef }) {

    let listArtRetours = [];
    let listArtSorties = [];

    let contratsRetours = contrats.filter((contrat) => dayjs(contrat.date2).isSame(dayjs(dateRef), "day"));
    let contratsSorties = contrats.filter((contrat) => dayjs(contrat.date1).isSame(dayjs(dateRef), "day"));

    contratsRetours.forEach(contrat => {
        contrat.ContratArticles.forEach((art) => {
            for (let i = 1; i <= art.qte; i++) {
                listArtRetours.push(art.article_id);
            }
        })
    })

    contratsSorties.forEach(contrat => {
        contrat.ContratArticles.forEach((art) => {
            for (let i = 1; i <= art.qte; i++) {
                listArtSorties.push(art.article_id);
            }
        })
    })

    return (
        <div className="ligne-total">
            <div className="ligne-total-intro">
                <p>{sens === "sorties" ? <UploadIcon /> : <DownloadIcon />}{sens} vélos</p>

            </div>
            <div className="ligne-total-cumul">
                <p>Total : {sens === "sorties" ? listArtSorties.length : listArtRetours.length}</p>

            </div>
            <div className="ligne-total-details">
                {/* <p><span>4</span>VTC F.</p>
                <p><span>4</span>VTC F.</p>
            <p><span>4</span>VTC F.</p> */}
                {sens === "sorties" ?
                    shortNamesList.map((art) => (
                        listArtSorties.filter((a) => (a === art.id_article)).length > 0 ?
                            <p>
                                <span>{listArtSorties.filter(a => a === art.id_article).length}</span>
                                {art.label}
                            </p>
                            : null
                    ))
                    :
                    shortNamesList.map((art) => (
                        listArtRetours.filter((a) => (a === art.id_article)).length > 0 ?
                            <p>
                                <span>{listArtRetours.filter(a => a === art.id_article).length}</span>
                                {art.label}
                            </p>
                            : null
                    ))
                }

                <p>&nbsp;</p>

            </div>


        </div>
    );
}

export default ligneTotalJour